import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import { ticketStyles } from '@totem/components/ticketing/details/ticketStyles';
import { ChartValue } from '@totem/components/ticketing/types';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  title: string;
  data: ChartValue[];
  totalDisplay: string;
  colors?: string[];
};

const ProjectChart = ({ data, title, totalDisplay, colors }: Props) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    // A small timeout ensures the chart container is fully visible
    // and its dimensions are correctly calculated before rendering.
    const timer = setTimeout(() => {
      setKey((prev) => prev + 1);
    }, 50);

    return () => clearTimeout(timer);
  }, [title, data, totalDisplay]); // Re-run when the tab/chart changes

  const options: ApexOptions = {
    chart: {
      type: 'donut',
      toolbar: { show: true, tools: { download: true } },
    },
    colors: isNotNull(colors)
      ? colors
      : [ticketStyles.colors.positive, ticketStyles.colors.negative],
    title: {
      text: title,
      align: 'center',
      offsetY: -5,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              fontSize: '20px',
              label: totalDisplay,
              formatter(): string {
                return '';
              },
            },
            value: {
              // Optional: Customize the individual slice percentage/value labels
              show: false,
            },
          },
        },
      },
    },
    legend: {
      show: true,
      position: 'bottom',
      customLegendItems: isNotNull(data) ? data.map((item) => item.label) : [],
    },
    tooltip: {
      enabled: true,
      custom({ seriesIndex }) {
        // Access the label from your original data using the dataPointIndex
        const label = data[seriesIndex].label;
        const value = data[seriesIndex].value;
        const formattedValue = value.toFixed(2);

        return (
          `<div class="custom-tooltip" style="padding: 4px">` +
          `<div>${label}: ${formattedValue}</div>` + // Display the label
          `</div>`
        );
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  return (
    <div className="project-chart-wrapper">
      <div className="app">
        <div className="row">
          <div className="mixed-chart">
            {isNotNull(data) && data.length > 0 && (
              <>
                <ReactApexChart
                  key={key}
                  options={options}
                  series={data.map((item) => item.value)}
                  labels={data.map((item) => item.label)}
                  type="donut"
                  width="100%"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectChart;
